import { render, staticRenderFns } from "./ShiftPatterns.vue?vue&type=template&id=65ced2f8&scoped=true&"
import script from "./ShiftPatterns.vue?vue&type=script&lang=js&"
export * from "./ShiftPatterns.vue?vue&type=script&lang=js&"
import style0 from "./ShiftPatterns.vue?vue&type=style&index=0&id=65ced2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ced2f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VDataTable,VIcon,VRow,VSnackbar})
